import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { environment } from '@env/environment';
import {
  GetPropostaResponse,
  GetPropostaStatusResponse,
  GetServicosAdicionaisResponse,
  UpdatePropostaClienteRequest,
  UpdatePropostaClienteResponse,
  ConfirmarPropostaRequest,
  ConfirmarPropostaResponse,
} from './proposta-editar.models';

/**
 * Service para Jornada Offline — Tela de Edição de Proposta
 * Gerencia operações de leitura, atualização parcial e confirmação de proposta
 */
@Injectable({
  providedIn: 'root',
})
export class PropostaEditarService extends BaseApiService {
  constructor() {
    super('proposta');
  }

  /**
   * Busca proposta por ID com todos os dados para edição
   * Inclui validação de ownership no backend
   * @param id CodigoProposta
   */
  getPropostaParaEditar(id: number): Observable<GetPropostaResponse> {
    return this.get<GetPropostaResponse>(`${id}`);
  }

  getPropostaStatus(id: number): Observable<GetPropostaStatusResponse> {
    return this.get<GetPropostaStatusResponse>(`${id}/status`);
  }

  getServicosAdicionais(id: number): Observable<GetServicosAdicionaisResponse> {
    return this.get<GetServicosAdicionaisResponse>(`${id}/servicos-adicionais`);
  }

  /**
   * Atualiza dados parciais da proposta (salvamento por seção)
   * @param id CodigoProposta
   * @param dados Dados a atualizar (apenas seções alteradas)
   */
  atualizarDadosProposta(
    id: number,
    dados: UpdatePropostaClienteRequest
  ): Observable<UpdatePropostaClienteResponse> {
    return this.put<UpdatePropostaClienteResponse>(dados, `${id}`);
  }

  /**
   * Confirma a proposta após preenchimento completo
    * Mantém status 1 e altera o substatus da jornada offline para concluída pelo cliente
   * @param id CodigoProposta
   */
  confirmarProposta(id: number): Observable<ConfirmarPropostaResponse> {
    return this.post<ConfirmarPropostaResponse>({}, `${id}/confirmar`);
  }

  getTermosOrganizacao(): Observable<string> {
    return this.http
      .get<any>(`${environment.BASE_API_URL}/integracoes-carsubs`)
      .pipe(
        map((response) => {
          const item = response?.data?.items?.[0] || {};
          return (
            item.TermosCondicoes ||
            item.termosCondicoes ||
            item.TermoCondicoes ||
            sessionStorage.getItem('termosCondicoes') ||
            ''
          );
        })
      );
  }

  confirmarPropostaComTermos(
    id: number,
    body: ConfirmarPropostaRequest
  ): Observable<ConfirmarPropostaResponse> {
    return this.post<ConfirmarPropostaResponse>(body, `${id}/confirmar`);
  }
}
